import mainCaller from './mainCaller';

// 이미지 단일 업로드
export async function uploadImage(file, token, directory) {
  const formData = new FormData();
  formData.append('file', file);
  const query = directory ? `?directory=${encodeURIComponent(directory)}` : '';
  return await mainCaller(`admin/api/v1/images/upload${query}`, 'POST', formData, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
}

// 이미지 다중 업로드
export async function uploadImages(files, token, directory) {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));
  const query = directory ? `?directory=${encodeURIComponent(directory)}` : '';
  return await mainCaller(`admin/api/v1/images/upload-multiple${query}`, 'POST', formData, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
}
